<template>
  <div ref="root">
    <slot />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useDefaults } from "#ce/composables/useDefaults";

const root = useTemplateRef("root");
const props = defineProps({});

useDefaults(props, root, "SpProviderAppointmentWidgetActions");
</script>

<style>
:host {
  display: block;
  margin: 0;
  padding: 0;
}
</style>
